import { EventEmitter } from '@angular/core';
var CheckboxComponent = (function () {
    function CheckboxComponent() {
        this.checkedValue = false;
        this.checkedChange = new EventEmitter();
        this.disabled = false;
        this.readonly = false;
    }
    Object.defineProperty(CheckboxComponent.prototype, "checked", {
        get: function () {
            return this.checkedValue;
        },
        set: function (val) {
            this.checkedValue = val;
            this.checkedChange.emit(this.checkedValue);
        },
        enumerable: true,
        configurable: true
    });
    CheckboxComponent.prototype.toggle = function () {
        if (this.disabled || this.readonly) {
            return;
        }
        this.checked = !this.checked;
    };
    CheckboxComponent.prototype.handleKeyboardEvent = function (event) {
        if (!this.focused || this.disabled || this.readonly) {
            return;
        }
        var x = event.keyCode;
        if (x === 32) {
            this.toggle();
            event.preventDefault();
        }
    };
    return CheckboxComponent;
}());
export { CheckboxComponent };



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/theme/components/checkbox/checkbox.component.ts.pre-build-optimizer.js